import { render, staticRenderFns } from "./Trends-Spec.vue?vue&type=template&id=bb4f62c6&scoped=true&"
import script from "./Trends-Spec.vue?vue&type=script&lang=js&"
export * from "./Trends-Spec.vue?vue&type=script&lang=js&"
import style0 from "./Trends-Spec.vue?vue&type=style&index=0&id=bb4f62c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb4f62c6",
  null
  
)

export default component.exports